<div
  *ngIf="pendingResults || hasResults; else noResults"
  class="home-search-results-container"
  role="dialog"
  aria-modal="true"
  aria-label="Results"
>
  <ng-container *ngIf="hasResults; else loading" role="navigation">
    <ng-container>
      @for (shop of shops; track shop._id) {
        <div
          [reactComponent]="ShopTileComponent$"
          tabindex="-1"
          class="hoverable home-search-results-shop-card"
          [props]="{
            shop,
            onRouterClick: this.onRouterClick.bind(this)
          }"
        ></div>
      }
    </ng-container>
  </ng-container>
  <ng-template #loading>
    <skeleton-shop-tile-compact></skeleton-shop-tile-compact>
    <skeleton-shop-tile-compact></skeleton-shop-tile-compact>
    <skeleton-shop-tile-compact></skeleton-shop-tile-compact>
    <skeleton-shop-tile-compact></skeleton-shop-tile-compact>
  </ng-template>
</div>
<ng-template #noResults>
  <box-empty-state [options]="emptyStateOptions"></box-empty-state>
</ng-template>
<div class="home-search-results-cta-wrapper">
  <button box-button theme="insignificant" size="small" (click)="onShowMoreClick()" aria-label="Show more results">
    {{ ctaText }}
  </button>
</div>
